import axios from 'axios'

export const postDataTracking = ({ trackIdentifierName, platform, deviceName, extras }) => {
  return axios.post('/data-tracking', {
    trackIdentifierName,
    platform,
    deviceName,
    extras,
  })
}

export const saveDataTracking = (trackIdentifierName, extras) => {
  try {
    const data = {
      trackIdentifierName,
      platform: getPlatform(),
      deviceName: localStorage.getItem('browserID'),
      extras: extras || JSON.stringify({ browser: navigator.userAgent }),
    }
    return postDataTracking(data)
  } catch (e) {}
}

export const isMobileBrowser = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
}

export function getPlatform() {
  let platform = ''
  if (
    ['fullscreen', 'standalone', 'minimal-ui'].some(
      (displayMode) =>
        window.matchMedia('(display-mode: ' + displayMode + ')').matches || window.navigator.standalone === true
    )
  ) {
    platform = 'APP - '
  }
  const browser = isMobileBrowser() ? 'MOBILE' : 'WEB'

  return `${platform}${browser}`
}
